//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            22nd October 2018
//  * @type            Main parent Component File
//  * @description -   This file renders the html and functionality that renders and manages all child components in the app.
<template>
  <div class="content_bg build_page" :class="{ 'published-survey': all.in_status == constantCommonConfig.SURVEY_PUBLISHED }">
    <div class="row m-0">
      <!-- <h1>{{ surveyData }}</h1> -->
      <!-- <button type="button" @click="logout">log out</button> -->
      <topbar-dashboard
        v-if="!isFullScreen"
        :show-tracey="showTraceyInHeader"
        @toggle-tracey="toggleAlexPanel"
      ></topbar-dashboard>

      <component :key="skipLogicKey" v-if="isSkipLogic === true" v-bind:is="skiplogicComponent"></component>
      <left-dashboard v-else></left-dashboard>

      <!-- <center-dashboard></center-dashboard>
      <right-dashboard></right-dashboard>-->
      <!-- <centerright v-if="isSkipLogic === true"></centerright> -->
      <component v-if="isSkipLogic === false" v-bind:is="centerComponent"></component>
      <component v-if="isSkipLogic === false" v-bind:is="rightComponent"></component>
    </div>

    <!-- Keep ChatPanel mounted after first open (v-show) so close/reopen preserves session and messages without a full page reload. -->
    <div
      v-if="isAiFormAllowed && alexChatMounted"
      v-show="alexOpen"
      class="alex-shell"
      role="presentation"
      :aria-hidden="alexOpen ? 'false' : 'true'"
    >
      <div class="alex-shell__backdrop" @click="closeAlex"></div>
      <aside
        class="alex-shell__drawer"
        :class="{
          'alex-shell__drawer--resizing': drawerResizing,
          'alex-shell__drawer--enter': drawerEnterActive
        }"
        :style="drawerStyle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tracey-drawer-title"
        @animationend="onDrawerEnterAnimationEnd"
        @click.stop
      >
        <div
          class="alex-shell__resize-handle"
          role="separator"
          aria-orientation="vertical"
          aria-label="Resize Tracey panel"
          title="Drag to resize"
          @mousedown.prevent="onDrawerResizeStart"
        ></div>
        <header class="alex-shell__header">
          <img
            class="tracey_image"
            :src="traceyFaceImg"
            alt=""
            width="72"
            height="72"
          />
          <div class="alex-shell__heading">
            <h2 id="tracey-drawer-title" class="alex-shell__title">
              Tracey
              <svg class="alex-shell__star" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 2l2.4 5.6L20 10l-5.6 2.4L12 18l-2.4-5.6L4 10l5.6-2.4L12 2z" />
              </svg>
            </h2>
            <p v-if="traceyDisplayName" class="alex-shell__subtitle">
              <span class="alex-shell__status-dot" aria-hidden="true"></span>
              <span class="alex-shell__subtitle-text">{{ traceyDisplayName }}</span>
            </p>
          </div>
          <div class="alex-shell__actions">
            <button type="button" class="alex-shell__close" @click="closeAlex" aria-label="Close Tracey assistant">
              ×
            </button>
          </div>
        </header>
        <div class="alex-shell__body">
          <ai-form-builder-chat-panel
            ref="traceyChatPanel"
            :key="traceyChatPanelKey"
            :survey-id="$route.params.id"
            :show-session-controls="false"
            embedded
            @applied="onAlexFormApplied"
            @survey-duplicated="onTraceySurveyDuplicated"
          />
        </div>
      </aside>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "../../main";
import topbarDashboard from "./topbar";
import leftDashboard from "./left";
import centerDesign from "./centerdesign";
import rightDesign from "./rightdesign";
import centerSetting from "./centersetting";
import rightSetting from "./rightsetting";
import centerQuestions from "./centerquestions";
import rightQuestions from "./rightquestions";
import skipLogic from "./skipLogic";
var { redirectUrl, constantCommonConfig } = require("../../../config/config.js");

const TRACEY_DRAWER_DEFAULT_WIDTH = 432;
const TRACEY_DRAWER_MIN_WIDTH = 320;
const TRACEY_DRAWER_MAX_WIDTH = 960;
const TRACEY_DRAWER_WIDTH_KEY = "tracey_drawer_width";

export default {
  name: "App",
  // props: ['surveyData'],
  metaInfo() {
    return {
      title: this.siteTitle
    };
  },
  components: {
    topbarDashboard,
    leftDashboard,
    centerDesign,
    rightDesign,
    centerSetting,
    rightSetting,
    centerQuestions,
    rightQuestions,
    skipLogic

    // surveyMobileSettings,
    // surveyOnlineSettings
  },
  data() {
    return {
      centerComponent: "centerQuestions",
      rightComponent: "rightQuestions",
      skiplogicComponent: "skipLogic",
      tab: null,
      data: [],
      constantCommonConfig: constantCommonConfig,
      siteTitle: '',
      alexOpen: false,
      /** Once true, Tracey shell stays in DOM (hidden with v-show) so chat state survives drawer close. */
      alexChatMounted: false,
      isAiFormAllowed: false,
      traceyDisplayName: "",
      traceyFaceImg: require("../../assets/images/tracey_face.png"),
      drawerWidth: TRACEY_DRAWER_DEFAULT_WIDTH,
      drawerResizing: false,
      drawerEnterActive: false,
      drawerResizeStart: null
    };
  },
  computed: {
    ...mapGetters("LeftSidebarCreate", ["isError", "all", "loading"]),
    ...mapGetters("editquestionEdit", [
      "isSkipLogic",
      "skipLogicKey",
      "isFullScreen"
    ]),
    /**
     * New value on each full browser load (reload / open tab) so Tracey remounts
     * and starts a new chat session. Same document + same survey => same key, so
     * closing/reopening the drawer keeps one session without a page reload.
     */
    traceyChatPanelKey() {
      const surveyId = this.$route.params.id || "survey";
      const origin =
        typeof performance !== "undefined" &&
        performance.timeOrigin != null &&
        !Number.isNaN(performance.timeOrigin)
          ? String(Math.floor(performance.timeOrigin))
          : "0";
      return "tracey-chat-" + surveyId + "-" + origin;
    },
    drawerStyle() {
      return {
        width: this.clampDrawerWidth(this.drawerWidth) + "px"
      };
    },
    showTraceyInHeader() {
      return this.isAiFormAllowed && !this.isSkipLogic;
    }
  },
  watch: {
    // As always only questions are to be displayed
    // tab: function(val) {
    //   if (val == "designleft") {
    //     this.centerComponent = "centerDesign";
    //     this.rightComponent = "rightDesign";
    //   } else if (val == "settingleft") {
    //     this.centerComponent = "centerSetting";
    //     this.rightComponent = "rightSetting";
    //   }
    // For rendering drag components pass component value in $emit tab value and set that variable directly for rendering.......
    // else {
    //   this.centerComponent = "centerQuestions";
    //   this.rightComponent = "rightQuestions";
    // }
    // },
    // Show progress bar bases on loading watcher
    loading: function(val) {
      if(val)
        this.$Progress.start();
      else {
        this.$Progress.finish();
      }
    },
    isError: function(val) {
      if (val) {
        window.location.href =
          redirectUrl + process.env.CAKE_BASE_PATH + "error";
        // this.$router.push({ name: "ErrorPage" });
      }
    },
    isAiFormAllowed(val) {
      if (!val) {
        this.alexOpen = false;
        this.alexChatMounted = false;
      }
    }
  },
  async created() {
    // Using the service bus
    EventBus.$on("LeftTabSelected", tab => {
      this.tab = tab;
    });
  },
  beforeMount: async function() {
    this.data = this.$session.getAll();
    // Resolved from /chatbot/feature/access (subscription + platform tbl_ai_llm_provider_config)
    this.isAiFormAllowed = false;
    this.data["in_survey_Id"] = this.$route.params.id;
    if (this.$route.path.includes("createform") || !this.all.flag)
      await this.getSurveyById(this.data);
    this.siteTitle = (this.$route.path.includes("createform")) ? 'Create Form' : (this.all.in_status == 1 ? 'Form' : 'Draft Form');
    await this.fetchAllSurveyTypes(this.data);
  },
  mounted: async function() {
    if (typeof window !== "undefined") {
      window.addEventListener("pageshow", this.onTraceyPageShow);
      window.addEventListener("resize", this.onTraceyLayoutResize);
    }
    this.loadDrawerWidth();
    await this.getWhiteLabelDetails();
    await this.fetchAiFormBuilderAccess();
  },
  beforeDestroy() {
    this.teardownDrawerResize();
    if (typeof window !== "undefined") {
      window.removeEventListener("pageshow", this.onTraceyPageShow);
      window.removeEventListener("resize", this.onTraceyLayoutResize);
    }
  },
  methods: {
    ...mapActions("LeftSidebarCreate", ["getSurveyById", "fetchAllSurveyTypes"]),
    onTraceySurveyDuplicated(payload) {
      const draftId = payload && payload.in_survey_Id ? String(payload.in_survey_Id) : "";
      if (!draftId) {
        return;
      }
      const whitelabel = this.$session.get("whitelabel");
      window.location.href =
        redirectUrl + "/" + whitelabel + "/editForms/" + draftId;
    },
    toggleAlexPanel() {
      if (!this.alexOpen) {
        this.alexChatMounted = true;
        this.drawerEnterActive = true;
      } else {
        this.drawerEnterActive = false;
      }
      this.alexOpen = !this.alexOpen;
    },
    loadDrawerWidth() {
      if (typeof window === "undefined") {
        return;
      }
      try {
        const raw = window.localStorage.getItem(TRACEY_DRAWER_WIDTH_KEY);
        if (!raw) {
          this.drawerWidth = TRACEY_DRAWER_DEFAULT_WIDTH;
          return;
        }
        const parsed = Number(raw);
        if (!Number.isFinite(parsed)) {
          this.drawerWidth = TRACEY_DRAWER_DEFAULT_WIDTH;
          return;
        }
        this.drawerWidth = this.clampDrawerWidth(parsed);
      } catch (e) {
        this.drawerWidth = TRACEY_DRAWER_DEFAULT_WIDTH;
      }
    },
    saveDrawerWidth() {
      if (typeof window === "undefined") {
        return;
      }
      try {
        window.localStorage.setItem(
          TRACEY_DRAWER_WIDTH_KEY,
          String(this.clampDrawerWidth(this.drawerWidth))
        );
      } catch (e) {
        /* ignore quota / private mode */
      }
    },
    getDrawerMaxWidth() {
      if (typeof window === "undefined") {
        return TRACEY_DRAWER_MAX_WIDTH;
      }
      return Math.min(TRACEY_DRAWER_MAX_WIDTH, Math.floor(window.innerWidth * 0.95));
    },
    clampDrawerWidth(width) {
      const maxWidth = this.getDrawerMaxWidth();
      return Math.max(
        TRACEY_DRAWER_MIN_WIDTH,
        Math.min(width, maxWidth)
      );
    },
    onTraceyLayoutResize() {
      this.drawerWidth = this.clampDrawerWidth(this.drawerWidth);
    },
    onDrawerResizeStart(ev) {
      if (ev.button !== 0) {
        return;
      }
      this.drawerResizing = true;
      this.drawerResizeStart = {
        clientX: ev.clientX,
        width: this.clampDrawerWidth(this.drawerWidth)
      };
      document.addEventListener("mousemove", this.onDrawerResizeMove);
      document.addEventListener("mouseup", this.onDrawerResizeEnd);
    },
    onDrawerResizeMove(ev) {
      if (!this.drawerResizeStart) {
        return;
      }
      const deltaX = ev.clientX - this.drawerResizeStart.clientX;
      this.drawerWidth = this.clampDrawerWidth(
        this.drawerResizeStart.width - deltaX
      );
    },
    onDrawerResizeEnd() {
      if (this.drawerResizeStart) {
        this.saveDrawerWidth();
      }
      this.teardownDrawerResize();
    },
    teardownDrawerResize() {
      document.removeEventListener("mousemove", this.onDrawerResizeMove);
      document.removeEventListener("mouseup", this.onDrawerResizeEnd);
      this.drawerResizing = false;
      this.drawerResizeStart = null;
    },
    closeAlex() {
      this.alexOpen = false;
      this.drawerEnterActive = false;
    },
    onDrawerEnterAnimationEnd(ev) {
      if (!ev || ev.target !== ev.currentTarget) {
        return;
      }
      if (ev.animationName === "alex-dr-in") {
        this.drawerEnterActive = false;
      }
    },
    /** BFCache restore: tear down Tracey so next open remounts and creates a new session. */
    onTraceyPageShow(ev) {
      if (ev && ev.persisted) {
        this.alexOpen = false;
        this.alexChatMounted = false;
      }
    },
    async onAlexFormApplied() {
      const data = this.$session.getAll();
      data["in_survey_Id"] = this.$route.params.id;
      await this.getSurveyById(data);
      EventBus.$emit("aiFormAppliedRefresh");
    },
    async getWhiteLabelDetails() {
      var parts = window.location.href.split('.')
      // parts[0] = 'http://hispec';
      // parts[1] = 'hispecservices';
      // parts[2] = 'com/doyenhub';
      if (parts[0].includes('//')) parts[0] = parts[0].split('//')[1]
      let domain = parts[0]
      let whitelabel = this.$route.params.whitelabel
      let url = process.env.API_PATH + "/getDomainDetails";
      await axios
        .post(
          url,
          {
            st_subdomain: domain,
            st_whitelabel: whitelabel
          },
          {
            headers: { "Content-Type": "application/json" }
          }
        )
        .then(response => {
          if (response.data.flag === 1) {
            var designdata = response.data.data;
            // Updating favicon according to whitelabel details
            if (designdata.favicon_image_url && designdata.favicon_image_url.length > 0) {
              const favicon = document.getElementById("favicon");
              favicon.href = designdata.favicon_image_url;
            }
          } else if (response.data.flag === 4) {
            console.log("invalid account name");
            this.$awn.alert("The page you requested does not exists.");
            var loc = location.host;
            var locArr = loc.split(".");
            loc = location.protocol + "//" + locArr[1] + "." + locArr[2];
            window.location.href = loc;
          } else {
            console.log("invalid url");
            this.$awn.alert("The page you requested does not exists.");
            window.location.href = redirectUrl;
          }
        })
        .catch();
    },
    async fetchAiFormBuilderAccess() {
      try {
        const res = await axios.post(
          process.env.API_PATH + "/chatbot/feature/access",
          {
            lang: this.$session.get("lang"),
            request_id: this.$session.get("requestId")
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: this.$session.get("jwt_token")
            }
          }
        );
        const allowed =
          res &&
          res.data &&
          res.data.flag === 1 &&
          Number(
            res.data.data && res.data.data.in_is_allow_ai_form != null
              ? res.data.data.in_is_allow_ai_form
              : 0
          ) === 1;
        const displayName =
          res &&
          res.data &&
          res.data.data &&
          res.data.data.st_display_name != null
            ? String(res.data.data.st_display_name).trim()
            : "";
        this.traceyDisplayName = displayName;
        this.isAiFormAllowed = allowed;
        if (!allowed) {
          this.alexOpen = false;
          this.alexChatMounted = false;
        }
      } catch (e) {
        this.isAiFormAllowed = false;
        this.alexOpen = false;
        this.alexChatMounted = false;
      }
    }
  }
};
</script>

<style scoped>
.build_page {
  position: relative;
}

.alex-shell {
  position: fixed;
  inset: 0;
  z-index: 1050;
  pointer-events: none;
}

.alex-shell__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.38);
  pointer-events: auto;
  animation: alex-bd-in 0.2s ease both;
}

@keyframes alex-bd-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.alex-shell__drawer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  max-width: 100vw;
  display: flex;
  flex-direction: column;
  background: #fff;
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.12);
  pointer-events: auto;
}

.alex-shell__drawer--enter {
  animation: alex-dr-in 0.24s cubic-bezier(0.4, 0, 0.2, 1) both;
}

.alex-shell__drawer--resizing {
  user-select: none;
}

.alex-shell__resize-handle {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 8px;
  cursor: col-resize;
  z-index: 2;
  touch-action: none;
}

.alex-shell__resize-handle:hover,
.alex-shell__drawer--resizing .alex-shell__resize-handle {
  background: rgba(74, 144, 217, 0.22);
}

@keyframes alex-dr-in {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.alex-shell__header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  padding: 0 16px 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
}

.tracey_image {
  flex-shrink: 0;
  align-self: flex-end;
  display: block;
  width: 72px;
  height: 72px;
}

.alex-shell__heading {
  flex: 1;
  min-width: 0;
  align-self: center;
}

.alex-shell__title {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.25;
  color: #1e293b;
  letter-spacing: -0.2px;
}

.alex-shell__star {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  fill: var(--buttonLinkColor, #2563c9);
}

.alex-shell__subtitle {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 1.3;
  color: #64748b;
}

.alex-shell__status-dot {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
}

.alex-shell__subtitle-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.alex-shell__actions {
  margin-left: auto;
  align-self: center;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.alex-shell__close {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  font-size: 24px;
  line-height: 1;
  color: #64748b;
  cursor: pointer;
  padding: 0;
  border-radius: 50%;
}

.alex-shell__close:hover {
  color: #0f172a;
  background: #f1f5f9;
}

.alex-shell__body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
<!-- <style lang="scss">
@import '../../assets/scss/style'
</style> -->



// WEBPACK FOOTER //
// src/components/Dashboard/Main.vue